// components/BackCardContent.js

import React, { forwardRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Barcode from "react-barcode";

const BackCardContent = forwardRef(({ user, STYLES }, ref) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div ref={ref}>
      <div style={STYLES.mainContent}>
        <div style={STYLES.leftSection}>
          {/* Student Address */}
          <div style={STYLES.fieldGroup}>
            <div style={{ ...STYLES.fieldLabel, textAlign: "center" }}>
              STUDENT ADDRESS
            </div>
            <div style={STYLES.fieldLine}>
              <div style={STYLES.fieldValue}>{user.address || ""}</div>
            </div>
          </div>

          {/* Parent/Guardian */}
          <div style={STYLES.fieldGroup}>
            <div style={{ ...STYLES.fieldLabel, textAlign: "center" }}>
              PARENT/GUARDIAN
            </div>
            <div style={STYLES.fieldLine}>
              <div style={STYLES.fieldValue}>{user.parent_guardian || ""}</div>
            </div>
          </div>

          {/* Table */}
          <div
            style={{
              marginTop: 12,
              transformOrigin: "top center",
              overflowX: "auto",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: isMobile ? 10 : 12,
                textAlign: "center",
                tableLayout: "fixed",
              }}
            >
              <thead style={{ display: "table-header-group" }}>
                <tr style={{ display: "table-row" }}>
                  {["YEAR", "1ST SEM.", "2ND SEM.", "SUMMER"].map((header) => (
                    <th
                      key={header}
                      style={{
                        display: "table-cell",
                        border: "1px solid #999",
                        padding: isMobile ? 2 : 4,
                        fontWeight: "bold",
                        overflowWrap: "break-word",
                      }}
                    >
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: 4 }).map((_, idx) => (
                  <tr key={idx} style={{ display: "table-row" }}>
                    {Array.from({ length: 4 }).map((__, cellIdx) => (
                      <td
                        key={cellIdx}
                        style={{
                          display: "table-cell",
                          border: "1px solid #999",
                          padding: isMobile ? 4 : 8,
                          height: 24,
                          overflowWrap: "break-word",
                        }}
                      />
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Note/Warning */}
          <div style={{ marginTop: 12 }}>
            <p style={{ fontSize: 10, fontWeight: "bold", margin: 0 }}>
              NOTE/WARNING:
            </p>
            <p
              style={{
                fontSize: 10,
                margin: "4px 0 0 0",
                textAlign: "justify",
                wordWrap: "break-word",
              }}
            >
              A holder of this card is a bonafide student of this UNIVERSITY.
              Improper use of this card like tampering, borrowing and lending is
              strictly prohibited. Violation will mean disciplinary action.
            </p>
          </div>

          {/* Creation Date and Codes with Note */}
          <div
            style={{
              marginTop: 12,
              fontSize: 10,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 8,
            }}
          >
            <div>
              <p style={{ margin: "2px 0" }}>
                Creation Date: {new Date().toISOString().split("T")[0]}
              </p>
              <p style={{ margin: "2px 0" }}>
                LRC No.: {user.lrc_no || "LRC-00-027"}
              </p>
              <p style={{ margin: "2px 0" }}>
                LC No.:{" "}
                {"LC-00-" +
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getFullYear() + 1)}
              </p>
            </div>

            {/* Note beside codes */}
            <div style={{ fontStyle: "italic", textAlign: "right" }}>
              <p style={{ margin: 0 }}>Valid only with</p>
              <p style={{ margin: 0 }}>Librarian's signature</p>
            </div>
          </div>

          {/* Barcode */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {user.library_id ? (
              <Barcode
                value={user.library_id}
                height={40}
                width={2}
                displayValue={false}
                background="transparent"
                style={STYLES.barcode}
              />
            ) : (
              <div
                style={{
                  fontSize: 10,
                  color: "#999",
                  textAlign: "center",
                  padding: "10px 0",
                }}
              >
                No Library ID Available
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

BackCardContent.displayName = "BackCardContent";

BackCardContent.propTypes = {
  user: PropTypes.shape({
    library_id: PropTypes.string,
    creation_date: PropTypes.string,
    lrc_no: PropTypes.string,
    lc_no: PropTypes.string,
    address: PropTypes.string,
    parent_guardian: PropTypes.string,
  }).isRequired,
  STYLES: PropTypes.object.isRequired,
};

export default BackCardContent;
